import MCPage from './MessageCenter';

export default MCPage;



// WEBPACK FOOTER //
// ./src/pages/messageCenter/index.jsx